module.exports = __webpack_public_path__ + "img/1566994982.adc6bead.jpg";